import { PropsWithChildren, createContext, useContext } from 'react'

import { useShallowMemo } from 'src/hooks/useShallowMemo'

type QuickActionContextValue = {
    closeMenu: () => void
    selectedText: string
}

type QuickActionProviderProps = PropsWithChildren<QuickActionContextValue>

const QuickActionContext = createContext<QuickActionContextValue | null>(null)

export const QuickActionProvider = (props: QuickActionProviderProps) => {
    const { selectedText, closeMenu, children } = props

    return <QuickActionContext.Provider value={useShallowMemo({ selectedText, closeMenu })}>{children}</QuickActionContext.Provider>
}

export const useQuickActionMenu = () => {
    const contextValue = useContext(QuickActionContext)

    if (contextValue === null) {
        throw new Error('`useQuickActionMenu` should only be used inside `QuickActionMenu`')
    }

    return contextValue
}
